import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  public open(message: string, duration?: number, action?: string): MatSnackBarRef<TextOnlySnackBar> {
    return this.snackBar.open(message, action || undefined, {
      duration: duration !== undefined ? duration : 5000,
      horizontalPosition: 'center',
    });
  }
}
